module.exports = __webpack_public_path__ + "static/media/carprice.933cfac4.png";